import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import { FaUser, FaEdit, FaPhoneAlt } from "react-icons/fa";
import swal from "sweetalert";

function Profile() {
  const token = localStorage.getItem("token");
  const user_id = localStorage.getItem("user_id");
  const [profile, setProfile] = useState({});
  const [isEditing, setIsEditing] = useState(false);
  const [formData, setFormData] = useState({
    username: "",
    mobile: "",
    email: "",
  });

  useEffect(() => {
    profilelist();
  }, []);

  const profilelist = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}/profile`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ id: user_id }),
      });

      if (!res.ok) throw new Error("Failed to fetch profile");

      const data = await res.json();
      setProfile(data.data);

      // set default values for form
      setFormData({
        username: data.data.username,
        mobile: data.data.mobile,
        email: data.data.email,
      });
    } catch (err) {
      console.error("Error fetching profile:", err);
    }
  };

  const profileEdit = async () => {
    try {
      const res = await fetch(
        `${process.env.REACT_APP_BASE_URL}/edit-profile`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            id: user_id,
            username: formData.username,
            mobile: formData.mobile,
            email: formData.email,
          }),
        }
      );

      const data = await res.json();

      if (data.status === "1") {
        setProfile(data.data);
        setIsEditing(false);

        // ✅ success message
        swal({
          title: "Success",
          text: data.message || "Profile updated successfully",
          icon: "success",
          button: false,
          timer: 2000,
        });
      } else {
        swal({
          title: "Warning",
          text: data.message || "Something went wrong",
          icon: "warning",
          button: false,
          timer: 2000,
        });
      }
    } catch (err) {
      console.error("Error updating profile:", err);

      swal("Error", "Failed to update profile", "error");
    }
  };

  return (
    <section className="bg-light">
      <Card className="shadow border-0">
        <Card.Header className="bg-primary text-white fw-bold ">
          <FaUser className="me-2" /> Profile Information
        </Card.Header>
        <Card.Body className="user_info">
          {!isEditing ? (
            <>
              <Row className="mb-3">
                <Col md={6}>
                  <h6 className="text-muted">Full Name</h6>
                  <p className="fw-semibold">{profile.username}</p>
                </Col>
                <Col md={6}>
                  <h6 className="text-muted">Phone Number</h6>
                  <p className="fw-semibold">
                    <FaPhoneAlt className="me-1" /> +91 {profile.mobile}
                  </p>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col md={6}>
                  <h6 className="text-muted">Email</h6>
                  <p className="fw-semibold">{profile.email || "Email"}</p>
                </Col>
                <Col md={6}>
                  <h6 className="text-muted">Joined On</h6>
                  <p className="fw-semibold">{profile.date}</p>
                </Col>
              </Row>

              <div className="d-flex justify-content-end">
                <button
                  className="educate-btn"
                  onClick={() => setIsEditing(true)}
                >
                  <span className="educate-btn__curve" />
                  <FaEdit className="me-1" /> Edit Profile
                </button>
              </div>
            </>
          ) : (
            <>
              {/* Editable form */}
              <Form>
                <Row className="mb-3">
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Full Name</Form.Label>
                      <Form.Control
                        type="text"
                        value={formData.username}
                        maxLength={60}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            username: e.target.value,
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Phone Number</Form.Label>
                      <Form.Control
                        type="text"
                        value={formData.mobile}
                        maxLength={10}
                        inputMode="numeric"
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            mobile: e.target.value.replace(/[^0-9]/g, ""),
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                  <Col md={6}>
                    <Form.Group>
                      <Form.Label>Email</Form.Label>
                      <Form.Control
                        type="email"
                        value={formData.email}
                        maxLength={42}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            email: e.target.value.replace(/\s+/g, ""),
                          })
                        }
                      />
                    </Form.Group>
                  </Col>
                </Row>
                <div className="d-flex justify-content-end">
                  <Button
                    variant="secondary"
                    onClick={() => setIsEditing(false)}
                  >
                    Cancel
                  </Button>
                  <button className="educate-btn" onClick={profileEdit}>
                    <span className="educate-btn__curve" />
                    Save Changes
                  </button>
                </div>
              </Form>
            </>
          )}
        </Card.Body>
      </Card>
    </section>
  );
}

export default Profile;
